import axios from "../../../utils/axios";

// Endpoint to fetch note access overrides
export async function fetchNoteAccessOverrides() {
    const response = await axios.get(
        `/practice-settings/providers-excluded-from-status-rules`
    );
    return response.data;
}
